import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NonInteractiveStepperStep } from '../../models/non-interactive-stepper-model';

@Component({
    selector: 'apcam-non-interactive-stepper',
    templateUrl: './non-interactive-stepper.component.html',
    imports: [NgClass, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NonInteractiveStepperComponent {
    protected readonly horizontalLayoutMaxSteps = 5;

    readonly steps = input.required<readonly NonInteractiveStepperStep[]>();
    readonly activeStep = input.required<number>();
    readonly ariaLabel = input.required<string>();
}
